import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';
import CurrentUserStore from '../stores/CurrentUserStore';
import CurrentUserActions from '../actions/CurrentUserActions';
import ForgotPasswordForm from '../forms/ForgotPasswordForm';


@AltIso.define((props) => {
    return SeoActions.pushTitle('Forgot Password');
})
class ForgotPasswordView extends React.Component {
    doRetrievePassword(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const data = this.refs.form.getValue();

        //var email = React.findDOMNode(this.refs.email).value.trim();
        //var password = React.findDOMNode(this.refs.password).value.trim();

        //console.log(email, password);
        if (data == null) {
            CurrentUserActions.failResetPasswordEmail({'email': 'Please enter a valid email.'});
        }

        if (data) {
            // Try to log the user in
            CurrentUserActions.failResetPasswordEmail({});
            CurrentUserStore.sendUserResetPasswordMail(data);
        }
    }

    render() {
        return (
            <div className="view-login view-forgotpassword maxwidth-wrapper">
                <div className="view-content">
                    <img className="site-logo" src={require('../styles/images/site-logo.svg')} alt="Gigpanel" />

                    <form className="whitebox login-form" onSubmit={this.doRetrievePassword.bind(this)}>
                        <h1>Forgot password</h1>

                        <ForgotPasswordForm ref="form" originalFormData={this.props.user.loginError.loginData || {}} loginError={this.props.user.resetEmailError} />

                        <button className="btn btn-orange form-control-submit">Retrieve password</button>
                    </form>

                    <p className="signup-cta">
                        <span>Already have an account?<Link to="login"> Log in</Link></span><br/>
                        <span>Don't have an account? <Link to="signup">Sign up</Link></span>
                    </p>
                </div>
            </div>
        );
    }
}

export default ForgotPasswordView;



/** WEBPACK FOOTER **
 ** ./app/src/views/ForgotPasswordView.js
 **/